import { loadedData } from '../load'
import { getFlagCatalog } from './flag-catalog'

export type FlagBearer = { readonly flags?: readonly string[] | null }

/**
 * True when the entity carries the flag string AND the platform flag table has that flag active.
 * Both sources are required: a deactivated flag stays in entity arrays, and the table is what
 * switches it off. Until the table has loaded, no flag counts. An absent entity or an entity
 * without flags has no flags.
 */
export const hasFlag = (entity: FlagBearer | null | undefined, key: string): boolean =>
    (entity?.flags?.includes(key) ?? false) && loadedData(getFlagCatalog())?.get(key) === true
